import { formatDurationAsClock } from 'utils/format_duration'

class DisplayCurrentTimeControl {
  constructor (video) {
    this.video = video
    this.unbinds = []

    this.unbinds.push(
      video.on('secondchange', () => this.updateButtonText())
    )
  }

  mountButton (buttonRoot) {
    this.buttonRoot = buttonRoot
    this.updateButtonText()
  }

  destroy () {
    this.unbinds.map(unbind => unbind())
    this.unbinds = []
  }

  updateButtonText () {
    this.buttonRoot.innerHTML = this.buttonText()
  }

  buttonText () {
    const time = this.video.time()

    // we format the time display based on the criteria above
    const formattedValue = formatDurationAsClock(time)

    return `<div class="wistia-custom-time-control"><p>${formattedValue}</p></div>`
  }
}

DisplayCurrentTimeControl.shouldMount = (video) => {
  return video._opts.displayCurrentTimeControl === true
}

DisplayCurrentTimeControl.handle = 'displayCurrentTime'
DisplayCurrentTimeControl.type = 'control-bar-right'
DisplayCurrentTimeControl.sortValue = 1
DisplayCurrentTimeControl.width = 80
DisplayCurrentTimeControl.isVideoChrome = true

export default DisplayCurrentTimeControl
